@if (showCanvas()) {
  <canvas #canvasEl role="img" [attr.aria-label]="alt()"></canvas>
} @else {
  <img [src]="src()" [alt]="alt()" />
}
